import * as React from 'react';
import { AbsenceListData } from '../types';
import { useStatusLabel, widgetDateRange } from './widgetFormat';

type Props = {
  data: AbsenceListData;
};

const AbsenceListWidget: React.FC<React.PropsWithChildren<Props>> = ({
  data,
}) => {
  const statusLabel = useStatusLabel();
  if (data.items.length === 0) {
    return null;
  }
  return (
    <div className="ai-chat-widget ai-chat-widget-absence-list">
      {data.items.map((item, idx) => (
        <div key={idx} className="ai-chat-widget-absence-list-row">
          <div className="ai-chat-widget-absence-list-main">
            <span className="ai-chat-widget-absence-list-category">
              {item.category}
            </span>
            <span className="ai-chat-widget-absence-list-date">
              {widgetDateRange(item.startDate, item.endDate, item.dateLabel)}
            </span>
          </div>
          <span
            className={`ai-chat-widget-status-pill ai-chat-widget-status-pill--${item.status}`}>
            {statusLabel(item.statusLabel)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default AbsenceListWidget;
